import { graphql } from "@/lib/gql/__generated__/gql";

export const PlanList_PlanListPage_Query = graphql(/* GraphQL */ `
	query PlanList_PlanListPage($hotelID: ID!) {
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				id
				hotelID
				planID
				inSale
				isPrivate
				isRequest
				isDayTrip
				isReservedAtLeastOnce
				name
				mainTarget
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				tags
				tagsLocation
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				availableRoomIDs
				availableOptionIDs
				requiredOptionIDs
				requiredOptionGroupIDs
				defaultDiscountID
				availableDiscountIDs
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				checkInStart
				checkInEnd
				checkOut
				longStayParams {
					minimumStayDates
				}
				shortStayParams {
					maximumStayDates
				}
				isUncancelable
				isUnchangeable
				isChangeOnlyOption
				roomChangeDisable
				maxRoomNum
				minRoomNum
				minimumPeopleNumPerRoom
				maxPeopleNumPerRoom
				notSendCinMail
				emailTemplateReservation {
					atCreated
					atUpdated
					atCanceled
					atCin
				}
				isNoAddressNeeded
				isShowRoomForGuest
				includedMeals
				questions {
					questionID
					required
					questionType
					question
					options
				}
				isHiddenHotelQuestions
				onlyUseLocalPayment
				onlyUseCreditPayment
				saleTypeForTerm
				saleStart
				saleEnd
				saleStartTime
				saleEndTime
				stayableStart
				stayableEnd
				stayableDayOfTheWeek
				checkInAvailableDayOfTheWeek
				requiredPrepMillisecond
				saleStartBeforeDate
				maxStockNum
				soldNumTotal
				maxDailyStockNum
				stockTypeTerm
				stockTypeTarget
				doNotCountKidsAsStock
				billingTypeTerm
				billingTypeTarget
				price {
					currencyType
					amount
				}
				# staticPriceParams {
				# 	staticRoomPrices {
				# 		roomID
				# 		roomName
				# 		prices {
				# 			adultNum
				# 		}
				# 	}
				# }
				isRoomPriceFree
				isSCConnected
				isCoSleepingKidsPriceActive
				coSleepingKidsPrice {
					currencyType
					amount
				}
			}
			secrets {
				id
				hotelID
				planID
				inSale
				isPrivate
				isRequest
				isDayTrip
				isReservedAtLeastOnce
				name
				mainTarget
				articleTitle
				availableRoomIDs
				availableOptionIDs
				requiredOptionIDs
				requiredOptionGroupIDs
				defaultDiscountID
				availableDiscountIDs
				checkInStart
				checkInEnd
				checkOut
				isUncancelable
				isUnchangeable
				isChangeOnlyOption
				roomChangeDisable
				maxRoomNum
				minRoomNum
				minimumPeopleNumPerRoom
				maxPeopleNumPerRoom
				notSendCinMail
				isNoAddressNeeded
				isShowRoomForGuest
				includedMeals
				isHiddenHotelQuestions
				onlyUseLocalPayment
				onlyUseCreditPayment
				saleTypeForTerm
				saleStart
				saleEnd
				saleStartTime
				saleEndTime
				stayableStart
				stayableEnd
				stayableDayOfTheWeek
				checkInAvailableDayOfTheWeek
				requiredPrepMillisecond
				saleStartBeforeDate
				maxStockNum
				soldNumTotal
				maxDailyStockNum
				stockTypeTerm
				stockTypeTarget
				doNotCountKidsAsStock
				billingTypeTerm
				billingTypeTarget
				isRoomPriceFree
				isSCConnected
				isCoSleepingKidsPriceActive
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				tags
				tagsLocation
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				longStayParams {
					minimumStayDates
				}
				shortStayParams {
					maximumStayDates
				}
				emailTemplateReservation {
					atCreated
					atUpdated
					atCanceled
					atCin
				}
				questions {
					questionID
					required
					questionType
					question
					options
				}
				price {
					currencyType
					amount
				}
				# staticPriceParams {
				# 	staticRoomPrices {
				# 		roomID
				# 		roomName
				# 		prices {
				# 			adultNum
				# 		}
				# 	}
				# }
				coSleepingKidsPrice {
					currencyType
					amount
				}
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
		siteControllerSetting(hotelID: $hotelID) {
			siteControllerType
			setUpRoomPriceByChillnn
		}
	}
`);
